import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestOptions } from '@angular/http';

import {
  AuthGuardService,
  CommercialService,
  CustomRequestOptions,
  DialogService,
  LoadingService,
  UserService
} from './services';

import {
  ITGroupGuard
} from './guards';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    AuthGuardService,
    CommercialService,
    {
      provide: RequestOptions,
      useClass: CustomRequestOptions
    },
    DialogService,
    ITGroupGuard,
    LoadingService,
    UserService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/core/core.module.ts